import React from 'react';
import { EventType } from '../../types';
import styles from './Badge.module.scss';

interface BadgeProps {
  type: EventType;
}

const typeLabels: Record<EventType, string> = {
  officiel: 'Officiel',
  foedselsdag: 'Fødselsdag',
  maerkedag: 'Mærkedag',
};

const Badge: React.FC<BadgeProps> = ({ type }) => {
  return (
    <span className={`${styles.badge} ${styles[type]}`}>
      {typeLabels[type]}
    </span>
  );
};

export default Badge;
